<dx-data-grid id="gridContainer" [dataSource]="convenioEmpresa?.Calculos && convenioEmpresa.Calculos"
  [showBorders]="true" [columnChooser]="false" [columnAutoWidth]="true" [keyboardNavigation]="true"
  (onEditorPreparing)="onEditorPreparing($event)" (onRowInserted)="onDataGridUpdated($event)"
  (onRowRemoved)="onDataGridUpdated($event)" (onRowUpdated)="onDataGridUpdated($event)" (onKeyDown)="onKeyDown($event)"
  (onRowValidating)="onRowValidating($event)" (onEditingStart)="onEditingStart($event)" (onToolbarPreparing)="onToolbarPreparing($event)">
  <dxo-group-panel [visible]="false"></dxo-group-panel>

  <!-- Definición de las columnas -->
  <dxi-column dataField="IdProvincia" caption="Provincia" dataType="string" [width]="250">
    <dxo-lookup [dataSource]="provincias" valueExpr="Id" displayExpr="Descripcion">
    </dxo-lookup>
    <dxi-validation-rule type="required" message="Es obligatorio"></dxi-validation-rule>
  </dxi-column>

  <dxi-column dataField="Descripcion" caption="Descripción" alignment="left" [width]="250">
  </dxi-column>

  <dxi-column dataField="CodigoCampoAmpliacionEmpleado" caption="Cód. plantilla ampl." alignment="left" [width]="250">
  </dxi-column>

  <dxi-column dataField="NombrePlantillaCampoAmpliacion" caption="Nom. plantilla ampl." alignment="left" [width]="250">
  </dxi-column>

  <dxi-column dataField="ValorCampoAmpliacionEmpleado" caption="Valor campo ampl." alignment="left" [width]="250">
  </dxi-column>

  <dxi-column dataField="NombreCampoAmpliacionEmpleado" caption="Nom. campo ampl." alignment="left" [width]="250">
  </dxi-column>

  <dxi-column dataField="CalcularParteProporcionalBolsaVacaciones" caption="Cálculo proporcional a F.Alta"
    dataType="boolean" alignment="center">
  </dxi-column>

  <dxi-column dataField="PermitirRedondeoAValorSuperior" caption="Redondeo a valor superior"
    dataType="boolean" alignment="center">
  </dxi-column>

  <dxi-column dataField="TipoDia" caption="Tipo día" [allowEditing]="true" dataType="string" [width]="125">
    <dxo-lookup [dataSource]="tiposDia" valueExpr="key" displayExpr="value">
    </dxo-lookup>
  </dxi-column>

  <dxi-column dataField="Dias" caption="T. días vac." dataType="number" alignment="right" [width]="150">
    <dxi-validation-rule type="required" message="Es obligatorio"></dxi-validation-rule>
  </dxi-column>

  <dxi-column dataField="DiasAdicionales" caption="Días vac. adicionales" dataType="number" alignment="right"
    [width]="150">
    <dxi-validation-rule type="required" message="Es obligatorio"></dxi-validation-rule>
  </dxi-column>

  <dxi-column dataField="DiasFestivos" caption="Días festivos" dataType="number" alignment="right" [width]="150">
    <dxi-validation-rule type="required" message="Es obligatorio"></dxi-validation-rule>
  </dxi-column>

  <dxi-column dataField="ContemplaDiasEnItVacaciones" caption="Contempla días en IT para vacaciones" dataType="boolean"
    alignment="center">
  </dxi-column>

  <dxi-column dataField="ContemplaDiasEnIt" caption="Contempla días en IT para la bolsa" dataType="boolean"
    alignment="center">
  </dxi-column>

  <dxi-column dataField="TieneBolsa" caption="Calcular bolsa de vacaciones" dataType="boolean" alignment="center" [width]="150">
  </dxi-column>

  <dxi-column dataField="DescartarFestivosCalendarioCentro" caption="Omitir festivos del calendario del centro"
    dataType="boolean" alignment="center" >
  </dxi-column>

  <dxi-column dataField="OrigenDatos" caption="Origen Datos" dataType="number" [width]="250">
    <dxo-lookup [dataSource]="origenDatos" valueExpr="key" displayExpr="value"></dxo-lookup>
  </dxi-column>

  <dxi-column dataField="ConceptoEmpleadoProrrateado" caption="Concepto empleado prorrateado" dataType="boolean"
    alignment="center">
  </dxi-column>

  <dxi-column dataField="SelectedEmployeeConcept" caption="Concepto empleado" dataType="number" [width]="250"
    editCellTemplate="employeeConceptSelectorTemplate">
    <dxo-lookup [dataSource]="payConcepts" valueExpr="conceptCode" displayExpr="description">
    </dxo-lookup>
  </dxi-column>

  <dxi-column dataField="SelectedPagasExtra" caption="Pagas Extra" dataType="number" [width]="250"
  editCellTemplate="extraPaysSelectorTemplate">
    <dxo-lookup [dataSource]="pagasExtra"></dxo-lookup>
  </dxi-column>

  <dxi-column dataField="SelectedVariableConcept" caption="Concepto variable" datatype="number" [width]="250"
    editCellTemplate="variableConceptSelectorTemplate">
    <dxo-lookup [dataSource]="payConcepts" valueExpr="conceptCode" displayExpr="description"></dxo-lookup>
  </dxi-column>

  <dxi-column dataField="SelectedPayConcepts" caption="Conceptos paga" datatype="number" [width]="250"
    editCellTemplate="payConceptsSelectorTemplate">
    <dxo-lookup [dataSource]="payConcepts" valueExpr="conceptCode" displayExpr="description"></dxo-lookup>
  </dxi-column>

  <dxo-editing mode="form" [allowUpdating]="esEditable" [allowDeleting]="esEditable" [allowAdding]="esEditable"
    [useIcons]="esEditable">
    <dxo-form [colCount]="2">
    </dxo-form>
  </dxo-editing>

  <div *dxTemplate="let cellInfo of 'employeeConceptSelectorTemplate'">
    <app-company-pay-concepts-selector dataSize="7" [(value)]="cellInfo.value"
      tooltipText="Concepto empleado - Concepto que permite conocer de cuanto es el importe que tiene asignado el empleado en su bolsa de vacaciones (y si tiene bolsa de vacaciones)"
      [entities]="payConcepts" [loading]="false" (valueChanged)="cellInfo.setValue($event)">
    </app-company-pay-concepts-selector>
  </div>

  <div *dxTemplate="let cellInfo of 'variableConceptSelectorTemplate'">
    <app-company-pay-concepts-selector dataSize="7" [(value)]="cellInfo.value"
      tooltipText="Concepto variable - Concepto contra el que se imputa un pago de la bolsa de vacaciones"
      [entities]="payConcepts" [loading]="false" (valueChanged)="cellInfo.setValue($event)">
    </app-company-pay-concepts-selector>
  </div>

  <div *dxTemplate="let cellInfo of 'payConceptsSelectorTemplate'">
    <app-company-pay-concepts-selector dataSize="7" [(value)]="cellInfo.value"
      tooltipText="Conceptos paga - Concepto a buscar en las pagas y que permite saber cuál es el total de la bolsa de vacaciones que se ha cobrado"
      multiple [entities]="payConcepts" [loading]="false" (valueChanged)="cellInfo.setValue($event)">
    </app-company-pay-concepts-selector>
  </div>

  <div *dxTemplate="let cellInfo of 'extraPaysSelectorTemplate'">
    <app-mat-select-filtered [items]="pagasExtra"
      [valueColumn]="'nombre'"
      [descriptionColumns]="['nombre']"
      ngbTooltip="Pagas extra - Pagas extra de las que se tomara el importe para el calculo de la bolsa de vacaciones" placement="bottom"
      [loading]="false" [multiple]="true" [ngModel]="cellInfo.value" (ngModelChange)="cellInfo.setValue($event)"
      name="extraPaysSelectedValue">
    </app-mat-select-filtered>
  </div>

  <div *dxTemplate="let data of 'clonateButton'">
    <!-- <button class="btn btn-primary btn-sm btn-add" type="button">
      <i class="material-icons">add</i> <span class="d-none d-sm-inline-block">Clonar</span></button> -->
      <button class="btn btn-primary" type="button" (click)="mostrarModalClonar()">
        <span class="d-none d-sm-inline-block">Clonar</span>
      </button>
  </div>

</dx-data-grid>

<dx-popup id="clonePopUp" class="popup" [width]="500" [height]="300" [showTitle]="true" title="Clonar configuración de convenio"
  [showCloseButton]="true" [dragEnabled]="false" [closeOnOutsideClick]="false" [visible]="false">
  <app-mat-select-filtered [items]="companySelectedAgreements" [valueColumn]="'Id'"
    [descriptionColumns]="['Descripcion']" [multiple]="false" [placeHolder]="'Convenios'"
    name="companySelectedAgreementValue" [(ngModel)]="companySelectedAgreementValueClone" (ngModelChange)="onSelectedAgreementChange($event)">
  </app-mat-select-filtered>
  <app-mat-select-filtered [items]="listaConfiguracionesConvenio" [valueColumn]="'Id'"
    [descriptionColumns]="['Descripcion']" [multiple]="false" [placeHolder]="'Configuraciones'"
    name="companySelectedAgreementValue" [(ngModel)]="configuracionSeleccionada">
  </app-mat-select-filtered>
  <!-- Botonera -->
  <div class="row fixed-bottom mr-3 mb-3">
    <div class="col-md-12">
      <div class="form-group">
        <button class="btn btn-fill btn-primary float-right" (click)="buttonClonarClick()" 
          [disabled]="!companySelectedAgreementValueClone || !configuracionSeleccionada">
          Clonar
        </button>
        <button class="btn btn-fill btn-outline-white float-right" type="button"
          (click)="buttonCerrarVentanaClonarClick()">
          Volver
        </button>
      </div>
    </div>
  </div>
</dx-popup>

<dx-load-panel
  #loadPanel
  shadingColor="rgba(0,0,0,0.4)"
  [position]="{ of: '#clonePopUp' }"
  [(visible)]="loading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true">
</dx-load-panel>